import React from "react";

export default function STTStatusBanner() {
  return (
    <div className="rounded-2xl border border-emerald-200 bg-emerald-50 text-emerald-800 px-4 py-3 text-sm">
      <strong>Speech-to-text:</strong> Google STT + OpenAI AI processing is active. Voice transcription is enabled for English, Hindi, Telugu, and mixed speech.
    </div>
  );
}
